import { useEffect, useState } from "react";
import CustomPagination from "../Pagination/CustomPagination";
import useStyles from "./style";
import { Box, Button, Flex, Table } from "@mantine/core";
import { getAllPatients } from "../../services/patient";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import { getAllStaff } from "../../services/staff";
import {
  getSkaiTokenPackages,
  getSkaiTokenUsage,
} from "../../services/skaiTokens";

const SubscriptionDetailsCard = () => {
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const { patients, loading: clientLoading } = useSelector(
    (state) => state.patient,
  );
  const [clientCurrentPage, setClientCurrentPage] = useState(1);
  const [staffCurrentPage, setStaffCurrentPage] = useState(1);
  const { classes } = useStyles();
  const {
    staffCount,
    staff,
    loading: staffLoading,
  } = useSelector((state) => state.staff);
  const tokenPackages = useSelector((state) => state.skai.tokenPackages);
  const usageData = useSelector((state) => state.skai.usageHistory);
  const usageArray = Array.isArray(usageData) ? usageData : [];
  const existingRecord = usageArray.find(
    (item) => item?.admin === profile?.user?.id,
  );
  const subscribedPackage = tokenPackages.find(
    (item) => item?._id === existingRecord?.aiPackageId,
  );

  useEffect(() => {
    getAllPatients(clientCurrentPage, true, true);
  }, [clientCurrentPage]);

  useEffect(() => {
    getAllStaff(staffCurrentPage, true, true, "");
  }, [staffCurrentPage]);

  useEffect(() => {
    getSkaiTokenPackages(true);
    getSkaiTokenUsage(profile?.user?.id);
  }, [profile?.user]);

  const handleClientPageChange = (pageNumber) => {
    setClientCurrentPage(pageNumber);
  };

  const handleStaffPageChange = (pageNumber) => {
    setStaffCurrentPage(pageNumber);
  };

  return (
    <Box className={classes.card}>
      <Flex className={classes.cardHdr}>
        <p className={classes.cardHdng}>Subscription Details</p>
      </Flex>
      <Box className={classes.tablesParent}>
        <Box className={classes.tableParent1}>
          <Table className={classes.table}>
            <thead>
              <tr>
                <th>Active Staffs</th>
              </tr>
            </thead>
            <tbody>
              {staffLoading ? (
                <tr>
                  <td>
                    <TableLoader />
                  </td>
                </tr>
              ) : staff?.staffs?.length > 0 ? (
                staff?.staffs?.map((staffData) => (
                  <tr>
                    <td>
                      {staffData?.name || ""}
                      {staffData?.role === "admin" ? " (Admin role)" : null}
                      {staffData?.isAdditionalStaff && (
                        <span className={classes.tdAmount}>
                          + ${staffData?.isAdditionalStaff}
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>No Staff</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Box>
        <Box className={classes.tableParent2}>
          <Table className={classes.table}>
            <thead>
              <tr>
                <th>Active Clients</th>
              </tr>
            </thead>
            <tbody>
              {clientLoading ? (
                <tr>
                  <td>
                    <TableLoader />
                  </td>
                </tr>
              ) : patients?.patients?.length > 0 ? (
                patients?.patients?.map((patientData) => (
                  <tr>
                    <td>
                      {patientData?.name || ""}
                      {patientData?.isAdditionalClient && (
                        <span className={classes.tdAmount}>
                          + ${patientData?.isAdditionalClient}
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>No Active Clients</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Box>
        <Box className={classes.tableParent3}>
          <Table className={classes.table}>
            <thead>
              <tr>
                <th>Add-on Features</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Skai
                  {existingRecord && subscribedPackage && (
                    <span className={classes.tdAmount}>
                      + ${subscribedPackage?.price}
                    </span>
                  )}
                </td>
              </tr>
              <tr>
                <td>Evv</td>
              </tr>
            </tbody>
          </Table>
        </Box>

      </Box>
      <Flex className={classes.paginationRow}>
        <Box className="tableWidth">
          <CustomPagination
            data={staffCount}
            itemsPerPage={10}
            currentPage={staffCurrentPage}
            handlePageChange={handleStaffPageChange}
          />
        </Box>
        <Box className="tableWidth">
          <CustomPagination
            itemsPerPage={10}
            data={patients?.count}
            currentPage={clientCurrentPage}
            handlePageChange={handleClientPageChange}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default SubscriptionDetailsCard;
